import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material";
import { Component, OnInit, Inject } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { TermInfoService } from "src/app/services/http/business/term-info/term-info.service";
import { CourseService } from "src/app/services/http/business/course/course.service";
//import { Router } from "@angular/router";
import { RegistrationService } from "src/app/services/http/business/registration/registration.service";
import { ErrorsService } from "src/app/services/common/errors.service";
import { InvoiceSummaryComponent } from "../../finance/payment/invoice-summary/invoice-summary.component";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-confirm-registration-entry",
  templateUrl: "./confirm-registration-entry.component.html",
  styleUrls: ["./confirm-registration-entry.component.css"]
})
export class ConfirmRegistrationEntryComponent implements OnInit {
  termName: string;
  termNumber: number;
  branchName: string;
  termInfoName: string;
  levelInfoName: string;
  coursePatternName: string;
  errObject: any;
  param: any;
  errorList: IError[] = [];
  errors = new Array();
  disable = false;

  constructor(
    //private router: Router,
    private dialog: MatDialog,
    public translate: TranslateService,
    private courseService: CourseService,
    private snackBar: SnackBarService,
    private termInfoService: TermInfoService,
    private errorService: ErrorsService,
    private registrationService: RegistrationService,
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<ConfirmRegistrationEntryComponent>
  ) {
  }

  ngOnInit() {
    this.getTermInfo();
    this.getCourseInfo();
  }

  getTermInfo() {
    this.termInfoService.getById(+this.data.TermInfoId).subscribe(res => {
      this.termNumber = res.TermNumber;
    });
  }

  getCourseInfo() {
    let course;
    this.courseService.list(0, 0).subscribe(res => {
      var courseList = res.DataList;
      //courseList.forEach(() => {
      course = courseList.filter(element => element.Id == this.data.CourseId);
      // });
      this.branchName = course[0].BranchName;
      this.coursePatternName = course[0].CoursePatternName;
      this.levelInfoName = course[0].LevelInfoName;
      this.termInfoName = course[0].TermInfoName;
    },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error)
      });
  }

  finalCOnfirm() {
    this.disable = true;
    this.registrationService.add(this.data).subscribe(() => {
      this.dialogRef.close();
      this.snackBar.OpenSnackBar(
        "ثبت دانشجو در کلاس با موفقیت انجام شد. لطفا فاکتور ثبت نام را پرداخت نمایید.",
        "ok",
        5000,
        SoundEnum.beep
      );
    },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error)
      });
  }

  navigateToPaymanet() {
    this.disable = true;
    this.registrationService.add(this.data).subscribe(res => {
      this.dialogRef.close();
      this.snackBar.OpenSnackBar(
        "ثبت دانشجو در کلاس با موفقیت انجام شد. لطفا فاکتور ثبت نام را پرداخت نمایید.",
        "ok",
        5000,
        SoundEnum.beep
      );
      this.dialog.open(InvoiceSummaryComponent, {
        width: '98%',
        data: {Id: parseInt(res.returnValue)}
      })
        .afterClosed()
        .subscribe(() => {
          this.dialogRef.close();
        });
    },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error)
      });
  }

  onCLose() {
    this.dialogRef.close();
  }
}
